module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/title-time/time-title.html
// module id = 836
// module chunks = 0